import moment from 'moment'
import { user_uid } from "@/general";
import { refreshToken, actualizaSesionUsuario } from "@/api";
import { crudModuloAplicacion } from "@/apis/security";

const actions = {
  updateProductPriceInCart({ state, commit }, product) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    if (!cartItem) return

    commit('updateProductPriceInCart', [
      product['valor_Producto'],
      cartItem
    ])
    commit('calculateProductsCost')
    commit('calculateIVACost')
    commit('calculateConsTax')
  },
  updateProductQtyInCart({ state, commit }, product) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    if (!cartItem && product['cantidad'] < 1) return

    if (!cartItem) {
      commit('pushProductToCart', product)
      commit('calculateProductsCost')
      commit('calculateIVACost')
      commit('calculateConsTax')
      return
    }

    if (product['cantidad'] < 1) {
      commit('popProductFromCart', product)
      commit('calculateProductsCost')
      commit('calculateIVACost')
      commit('calculateConsTax')
      return
    }

    commit('updateItemQuantity', [
      product['cantidad'],
      product
    ])
    commit('calculateProductsCost')
    commit('calculateIVACost')
    commit('calculateConsTax')

  },
  addProductToCart({ state, commit }, product) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    if (!cartItem) {
      commit('pushProductToCart', product)
    } else {
      commit('incrementItemQuantity', cartItem)
    }
    commit('calculateProductsCost')
    commit('calculateIVACost')
  },
  removeProductFromCart({ state, commit }, product) {
    const cartItem = state.cart.items.find(item => item['id_Producto'] === product['id_Producto'])
    if (cartItem) {
      if (cartItem['cantidad']) {
        if (cartItem['cantidad'] == 1) {
          commit('popProductFromCart', product)
        } else {
          commit('decrementItemQuantity', cartItem)
        }
      }
      commit('calculateProductsCost')
      commit('calculateIVACost')
    }
  },
  async registerApplicationModule({ state, commit }, module) {
    try {
      const data = {
        "modulo": module.module,
        "descripcion": module.description,
        "ruta_Modulo": module.route
      }


      const { count } = await crudModuloAplicacion(state, "get", null, data);
      
      if (count !== 1) {
        await crudModuloAplicacion(state, "create", null, data);

        commit("setUserValue", ["ModulosAplicacion", [ ...data ]]);
        // commit('setUserValue', ['data', {...userData, routesAccessModel: routesModel }])
      }
    } catch(error) {
      console.warn(error);
    }
  },
  async statusLogin({ state, commit }, router) {
    try {
      const now = moment();
      let timelapseSession = now.diff(state.user.logginDate, 'minutes');
      
      if (timelapseSession >= state.user.data.minutos_ExpiracionToken) {
        if ((timelapseSession - state.user.data.minutos_ExpiracionToken) < 5) {
          const { token } = await refreshToken(state.user.tokenRefresh);

          if (token) {
            commit('setUserValue', ['token', token]);
            commit('setUserValue', ['logginDate', moment().format()]);
          } else {
            await actualizaSesionUsuario(this, user_uid(), 'I');

            throw "No token refresh available"
          }
        } else {
          await actualizaSesionUsuario(this, user_uid(), 'I');
          
          throw "Session expired"
        }
      }

      if (state.user.tokenRefresh === '') {
        await actualizaSesionUsuario(this, user_uid(), 'I');

        throw "No token refresh available"
      }

      // const { token } = await refreshToken(state.user.tokenRefresh);

      // if (token) {
      //   commit('setUserValue', ['token', token]);
      // }
    } catch (err) {
      commit('setMInterval', ['cancel', null])
      commit('setUserValue', ['token', ''])
      commit('setUserValue', ['tokenRefresh', ''])
      commit('setUserValue', ['isLoggedIn', false])
      commit('setUserValue', ['logginDate', ''])
      commit('setUserValue', ['data', {}]);

      commit('resetCart')
      commit('resetQuote')
      commit('set', ['quoteActiveTab', 0])

      commit('setAlert', {
        color: 'info',
        message: 'Su sesión ha caducado',
        show: 5
      });

      router.push({ path: "/login" });
    }
  }
}

export default actions
